import React from "react";
import { useTranslation } from "react-i18next";
import Seo from "./Seo";
import Home from "./Home";
import About from "./About";
import Education from "./Education";
import Projects from "./Projects";
import Skill from "./Skills";

interface MainPageProps {
  lang: "de" | "en";
}

const MainPage: React.FC<MainPageProps> = ({ lang }) => {
  const { t } = useTranslation();

  return (
    <>
      <Seo
        lang={lang}
        path="/"
        title={t("seo.homeTitle")}
        description={t("seo.homeDescription")}
        keywords={t("seo.keywords") as string}
      />
      <div className="snap-container">
        <Home />
        <About />
        <Education />
        <Projects />
        <Skill />
      </div>
    </>
  );
};

export default MainPage;
